import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, exhaustMap, map, mergeMap, tap } from 'rxjs/operators';
import { PaymentAdapter } from '../../adapters/payment.adapter';
import {
  loadPayment,
  loadPaymentFailure,
  loadPaymentSuccess,
  updateBillingAddress,
  updateBillingAddressFailure,
  setBankTransfer,
  setBankTransferFailure,
  setBankTransferSuccess,
  updateBillingAddressSuccess,
} from './payment.actions';

@Injectable()
export class PaymentEffects {
  private readonly actions$ = inject(Actions);
  private readonly paymentAdapter = inject(PaymentAdapter);
  
  loadPayment$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadPayment),
      exhaustMap(() =>
        this.paymentAdapter.getPaymentInformation().pipe(
          map((paymentInformation) => loadPaymentSuccess({ paymentInformation })),
          catchError((error) => {
            return of(loadPaymentFailure({ error }));
          })
        )
      )
    )
  );

  updateBillingAddress$ = createEffect(() =>
    this.actions$.pipe(
      ofType(updateBillingAddress),
      mergeMap((props) =>
        this.paymentAdapter.updateBillingAddress(props.billingAddress).pipe(
          map(() => updateBillingAddressSuccess({ billingAddress: props.billingAddress })),
          catchError((error) => {
            return of(updateBillingAddressFailure({ error }));
          })
        )
      )
    )
  );

  setBankTransfer$ = createEffect(() =>
    this.actions$.pipe(
      ofType(setBankTransfer),
      mergeMap(() =>
        this.paymentAdapter.setBankTransfer().pipe(
          map(() => setBankTransferSuccess()),
          catchError((error) => {
            return of(setBankTransferFailure({ error }));
          })
        )
      )
    )
  );

  loadPaymentFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(loadPaymentFailure),
        tap((action) => {
          // Todo: Add proper error handling. Maybe with a toasty?
          //alert(action.error.message);
        })
      ),
    { dispatch: false }
  );
}
